import immutableCollections from 'rlink-collections/immutable';
import setMemberCollectionsFactory from 'rlink-collections/setMemberCollectionsFactory';
import ConstructableContainer from 'rlink-data-connector/storage/ConstructableContainer';

const storageCollections = immutableCollections.withImplementations(
  setMemberCollectionsFactory(
    ConstructableContainer,
    ['type', 'data', 'constructInstance'],
    ({type, data, constructInstance}) => new ConstructableContainer(type, data, constructInstance)
  )
);

export default storageCollections;

const {
  constructsUsing,
  copyGenerator,
  count,
  deepCopy,
  deepEquals,
  entries,
  getAt,
  hasKey,
  isCollection,
  isIterable,
  iterate,
  keys,
  makeShapeTemplate,
  setAt,
  updateAt,
  valueCopy,
  valueEquals,
  valueForKey,
  valueGetters,
  values,
  yieldableFor,
} = storageCollections;

export {
  constructsUsing,
  copyGenerator,
  count,
  deepCopy,
  deepEquals,
  entries,
  getAt,
  hasKey,
  isCollection,
  isIterable,
  iterate,
  keys,
  makeShapeTemplate,
  setAt,
  updateAt,
  valueCopy,
  valueEquals,
  valueForKey,
  valueGetters,
  values,
  yieldableFor,
};



// WEBPACK FOOTER //
// ./lib/rlink-data-connector/storage/collections.js